import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {DEFAULT_EMPTY_VALUE_REPLACEMENT_STRING} from '@aviary/store/common/common.types';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';

@Component({
  selector: 'px-catalog-search-cover-and-details-column',
  templateUrl: './cover-and-details-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverImageComponent, NamedRouterLinkDirective, SelectPipe, FormatPipe, LinkButtonComponent, ButtonRouteNameDirective]
})
export class CoverAndDetailsColumnComponent {
  @Input({required: true}) public catalogRecord: CatalogRecord;

  public readonly selectors = CatalogSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly DEFAULT_EMPTY_VALUE_REPLACEMENT_STRING = DEFAULT_EMPTY_VALUE_REPLACEMENT_STRING;
}
